import SendConfirm from './SendConfirm';

export default SendConfirm;
